import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { deleteBlobFile } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function postDeleteFile({
  accountId,
  params,
}: TVariables): Promise<TResult> {
  const response = await fetch(deleteBlobFile(accountId), {
    method: 'DELETE',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  params: {
    Title: string;
    Container: string;
  };
  accountId: number;
};

type TSnapshot = unknown;

function useDeleteBlobFile(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ accountId, params }: TVariables) => {
    const renamedResult = await postDeleteFile({ accountId, params });
    if (renamedResult.Data) {
      queryClient.invalidateQueries(['get_file_tree'], {
        refetchInactive: true,
      });
    } else if (renamedResult.Errors) throw renamedResult;
    queryClient.removeQueries(['get_accounts_list_for_import_files']);
    return renamedResult;
  });
}

export { useDeleteBlobFile };
